import { fetchMetrics } from '../helpers';

const firePixel = (id, data) => {
  const pixel = `//googleads.g.doubleclick.net/pagead/viewthroughconversion/${id}/?value=0&guid=ON&script=0&${data}`;
  fetchMetrics(pixel);
};

const getLineId = breadCrumb => {
  const bc = breadCrumb[1] || breadCrumb[0] || [{ id: 0 }];
  return bc.id;
};

const getDepartamentId = breadCrumb => {
  const bc = breadCrumb[0] || [{ id: 0 }];
  return bc.id;
};

const dispatchSearch = (id, searchProducts) => {
  let data = 'data.ET=busca&ecomm_pagetype=busca';
  data += searchProducts.slice(0, 3).map(productId => `&data.prodid=${productId}&ecomm_prodid=${productId}`);
  firePixel(id, data);
};

const dispatchProduct = (id, product, offer, breadCrumb) => {
  const data = `&data.ET=product&data.pagetype=product&data.lineid=${getLineId(
    breadCrumb
  )}&data.pcat=${getDepartamentId(breadCrumb)}&data.category=${getDepartamentId(breadCrumb)}&data.prodid=${
    product.id
  }&data.pvalues=${offer.salesPrice}&data.totalvalue=${offer.salesPrice}`;
  firePixel(id, data);
};

export const googleRmktInit = config => {
  document.addEventListener('page:load', ({ detail }) => {
    try {
      const { page, product, mainOffer, offers, search } = detail;
      const id = config.googlermkt;
      if (!page || !id) {
        return false;
      }

      const { type, breadCrumb } = page;
      if (type === 'home') {
        firePixel(id, 'data.ET=home&ecomm_pagetype=home');
      }
      if (type === 'product') {
        const offer = mainOffer || offers[0];
        dispatchProduct(id, product, offer, breadCrumb);
      }
      if (type === 'search' && search && search.products) {
        dispatchSearch(id, search.products);
      }
    } catch (e) {
      console.warn('GOOGLERMKT', e);
    }
  });
};
